module.exports = __webpack_public_path__ + "img/editPage_list.35d3fd76.svg";